<template>
    <div>
        <div>
            <div>

                <!-- HEADER -->
                <!-- <div class="header">
                    <div class="btn-group" role="group">
                        <button v-on:click="getrapportglobal()" type="button" class="btn waves-effect waves-light"
                            :class="{ 'bg-blue-grey': rapportfilter == 'global' }" data-toggle="modal"
                            data-target="#globalrapport">RAPPORT GLOBAL</button>
                        <button v-on:click="rapportfilter = 'indiv'" type="button"
                            :class="{ 'bg-blue-grey': rapportfilter == 'indiv' }"
                            class="btn waves-effect waves-light">RAPPORT INDIVIDUEL</button>
                    </div>
                </div> -->

                <!-- TABLE -->
                <!-- <div v-if="this.employees.length == 0" class="alert bg-black">
                    <center>Pas de données trouvées</center>
                </div>
                <div v-else class="body">
                    <div class="table-responsive" v-if="!table_load">
                        <table class="table table-bordered table-striped table-hover tableEmployee">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Matricule</th>
                                    <th>Nom</th>
                                    <th>Prénoms</th>
                                    <th>Email</th>
                                    <th>Contact</th>
                                    <th>Type de contrat</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="employee in employees" :key="employee.id"
                                    v-on:click="getrapportindiv(employee.id)" data-toggle="modal"
                                    data-target="#individualrapport">
                                    <td> {{ employee.id }} </td>
                                    <td>
                                        <div class="form-line">
                                        {{ employee.matricule }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            {{ employee.first_name }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            {{ employee.last_name }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            {{ employee.email }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            {{ employee.phone }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-line">
                                            <span>{{ employee?.profile[0]?.pivot.contract_type ?? "Aucun contrat" }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            v-on:click="updateEmployee(employee.id,employee.matricule, employee.first_name, employee.last_name, employee.email, employee.phone, employee.profile_id, employee.shift, employee.status)"
                                            type="button"
                                            class="btn bg-blue btn-circle waves-effect waves-circle waves-float">
                                            <i class="material-icons">send</i>
                                        </button>
                                        -
                                        <button v-on:click="removeEmployee(employee.id)" type="button"
                                            class="btn bg-red btn-circle waves-effect waves-circle waves-float">
                                            <i class="material-icons">delete</i>
                                        </button>
                                        -
                                        <button v-on:click="pushDetails(employee.id)" type="button"
                                            class="btn bg-green btn-circle waves-effect waves-circle waves-float">
                                            <i class="material-icons">visibility</i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style="display: flex; justify-content:center" v-else>
                        <div class="preloader pl-size-xs">
                            <div class="spinner-layer pl-indigo">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <!-- RAPPORT GLOBAL -->
    <div class="modal fade" id="globalrapport" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content w-[95vw] translate-x-[-17%]">
                <div id="global">
                    <div class="modal-body table-responsive">
                        <div v-if="!rapport_load">
                            <h3>
                                <center><span class="label bg-black">Rapport de présence global</span> </center>
                                <div class="flex items-center gap-x-2">
                                    <input type="date" class="p-3 border rounded-md text-black cursor-pointer" v-model="date">
                                    <button class="px-5 py-3 rounded-md border text-black" v-on:click="getrapportglobal()">
                                        Actualiser
                                    </button>
                                </div>
                            </h3>
                            <center style="margin-bottom: 15px; margin-top: 15px;"><span>Période du {{ rapport.debut }} au
                                    {{ rapport.fin }}</span></center>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>
                                            <center>#</center>
                                        </th>
                                        <th>
                                            <center>Nom<br>Prénoms</center>
                                        </th>
                                        <th>
                                            <center>Nombre<br>Présences</center>
                                        </th>
                                        <th>
                                            <center>Nombre<br>Absences</center>
                                        </th>
                                        <th>
                                            <center>Nombre<br>Retards</center>
                                        </th>
                                        <th>
                                            <center>
                                                Départs anticipé
                                            </center>
                                        </th>
                                        <th>
                                            <center>
                                                Arrivée moyenne
                                            </center>
                                        </th>
                                        <th>
                                            <center>
                                                Départ moyen
                                            </center>
                                        </th>
                                        <th>
                                            <center>
                                                Heures de Travail
                                            </center>
                                        </th>
                                        <th>
                                            <center>
                                                Heure supplémentaire
                                            </center>
                                        </th>
                                        <th>
                                            <center>
                                                Taux ponctualité
                                            </center>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in rapport.users" :key="user.id">
                                        <td>
                                            <center>{{ user.order }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.first_name }} {{ user.last_name }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.presences }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.absences }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.retards }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.departs }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.moyennearrivee }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.moyennedepart }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.ratespresences }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.overtime }}</center>
                                        </td>
                                        <td>
                                            <center>{{ user.ratesponctuality }}%</center>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else style="display: flex; justify-content:center; margin-top: 50px;">
                            <div class="preloader pl-size-xs">
                                <div class="spinner-layer pl-indigo">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-success waves-effect" v-on:click="excel('global')">EXCEL</button>
                     <button type="button" class="btn btn-primary waves-effect" v-on:click="ExportToExcel('xlsx', null, null,'global')">XLSX</button>
                    <button type="button" class="btn btn-primary waves-effect" v-on:click="pdf('global')">PDF</button>
                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">X</button>
                </div>
            </div>
        </div>
    </div>

    <!-- RAPPORT INDIVIDUEL -->
    <!-- <div v-if="rapportfilter == 'indiv'">
        <div class="modal fade" id="individualrapport" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content w-[95vw] translate-x-[-17%]">
                    <div id="indiv">
                        <div class="modal-body table-responsive">
                            <div v-if="!rapport_load">
                                <h3>
                                    <center><span class="label bg-black">Rapport de présence: {{
                                        indivrapport.user.first_name
                                    }} {{ indivrapport.user.last_name }} </span> </center>
                                    <div class="flex items-center gap-x-2">
                                    <input type="date" class="p-3 border rounded-md text-black cursor-pointer" v-model="date2">
                                    <button class="px-5 py-3 rounded-md border text-black" v-on:click="getrapportglobal()">
                                        Actualiser
                                    </button>
                                </div>
                                </h3>
                                <center style="margin-bottom: 15px; margin-top: 15px;"><span>Période du {{
                                    indivrapport.debut }}
                                        au
                                        {{ indivrapport.fin }}</span></center> -->

                                <!-- <span class="label bg-blue-grey">Resumé</span>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                <center>Nombre<br>Présences</center>
                                            </th>
                                            <th>
                                                <center>Nombre<br>Absences</center>
                                            </th>
                                            <th>
                                                <center>Nombre<br>Retards</center>
                                            </th>
                                            <th>
                                                <center>
                                                    Départs<br>anticipé
                                                </center>
                                            </th>
                                            <th>
                                                <center>
                                                    Arrivée<br>moyenne
                                                </center>
                                            </th>
                                            <th>
                                                <center>
                                                    Départ<br>moyen
                                                </center>
                                            </th>
                                            <th>
                                                <center>
                                                    Heures<br>de Travail
                                                </center>
                                            </th>
                                            <th>
                                                <center>
                                                    Heures<br>Supplémentaire
                                                </center>
                                            </th>
                                            <th>
                                                <center>
                                                    Taux<br>ponctualité
                                                </center>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <center>{{ indivrapport.user.presences }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.absences }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.retards }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.departs }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.moyennearrivee }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.moyennedepart }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.ratespresences }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.overtime }}</center>
                                            </td>
                                            <td>
                                                <center>{{ indivrapport.user.ratesponctuality }}%</center>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <span class="label bg-blue-grey">Exceptions</span>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                <center>Type</center>
                                            </th>
                                            <th>
                                                <center>Début</center>
                                            </th>
                                            <th>
                                                <center>Fin</center>
                                            </th>
                                            <th>
                                                <center>Temps manqué</center>
                                            </th>
                                            <th>
                                                <center>
                                                    Statut
                                                </center>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="exception in indivrapport.exceptions" :key="exception.id">
                                            <td>
                                                <center>{{ exception.type.label }}</center>
                                            </td>
                                            <td>
                                                <center>{{ exception.date_start }}</center>
                                            </td>
                                            <td>
                                                <center>{{ exception.date_end }}</center>
                                            </td>
                                            <td>
                                                <center>{{ exception.hour_issue }}</center>
                                            </td>
                                            <td>
                                                <center>
                                                    <span v-if="exception.state == '2'"
                                                        class="label label-default bg-green">VALIDÉE</span>
                                                    <span v-else-if="exception.state == '1'"
                                                        class="label label-default bg-orange">EN COURS DE VALIDATION</span>
                                                    <span v-else class="label label-default bg-red">NON JUSTIIÉE</span>
                                                </center>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                 -->
                                <!-- <span class="label bg-blue-grey">Présences</span>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                <center>Date</center>
                                            </th>
                                            <th>
                                                <center>Arrivée</center>
                                            </th>
                                            <th>
                                                <center>Départ</center>
                                            </th>
                                            <th>
                                                <center>Zone</center>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="presence in indivrapport.presences" :key="presence.id">
                                            <td>
                                                <center>{{ presence.created_at }}</center>
                                            </td>
                                            <td>
                                                <center>{{ presence.hour_start }}</center>
                                            </td>
                                            <td>
                                                <center>{{ presence.hour_end }}</center>
                                            </td>
                                            <td>
                                                <center>{{ presence.zone.label }}</center>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> -->

                            <!-- </div>
                            <div v-else style="display: flex; justify-content:center; margin-top: 50px;">
                                <div class="preloader pl-size-xs">
                                    <div class="spinner-layer pl-indigo">
                                        <div class="circle-clipper left">
                                            <div class="circle"></div>
                                        </div>
                                        <div class="circle-clipper right">
                                            <div class="circle"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary waves-effect" v-on:click="ExportToExcel('xlsx', null, null,'indiv')">XLSX</button>
                        <button type="button" class="btn btn-primary waves-effect" v-on:click="pdf('indiv')">PDF</button>
                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">X</button>
                    </div>
                </div>
            </div>
        </div>
    </div>  -->
    <div class="">
        <CustomTable :data="employees" :columnsCustom="columnn" :load="table_load">
            <template #other-filter>
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-x-[8px]">
                        <button v-on:click="getData('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                            <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                        </button>
                        <button @click="selectType('actif')" :class="['h-[35px] font-light px-4 border rounded-xl flex items-center justify-center',{'bg-gray-100': filter_status == 'actif'}]">
                            Employées actifs
                        </button>
                        <button @click="selectType('disable')" :class="['h-[35px] font-light px-4 border rounded-xl flex items-center justify-center',{'bg-gray-100': filter_status == 'disable'}]">
                            Anciens employées
                        </button>
                        <button v-on:click="getrapportglobal()" data-toggle="modal" data-target="#globalrapport" class="h-[35px] font-light px-4 border rounded-xl flex items-center justify-center">
                            Rapport global
                        </button>
                    </div>

                    <button v-on:click="exportData" class="bg-[#3c41e9] font-light gap-x-[8px] rounded-xl text-white px-4 h-[35px] flex items-center justify-center">
                        <FolderUp :size="16"/>
                        Exporter
                    </button>
                </div>
            </template>
            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 1">
                    <div class="flex items-center gap-x-[6px]">
                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                        <div class="flex flex-col items-start">
                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                            <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span>
                        </div>
                    </div>
                </span>
                <span v-else-if="slotProps.cellNumber == 6">
                    <button v-on:click="pushDetails(slotProps.value)" class="h-[35px] flex items-center px-[12px] min-w-[90px] rounded-xl text-white bg-[#3c41e9]">Voir détails</button>
                </span>
                <span v-else>{{ slotProps.value }}</span>
            </template>
        </CustomTable>
    </div>
</template>

<script>

import html2pdf from "html2pdf.js"
import Swal from 'sweetalert2'
import API from "@/service/API";
import CustomTable from "./Custom-table.vue";
import {createColumnHelper} from "@tanstack/vue-table";
import * as XLSX from 'xlsx/xlsx.mjs';
import router from "@/router/index.js";
import {RefreshCw,FolderUp} from "lucide-vue-next";

const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => row.matricule, {
    id: 'matricule',
    header: 'Matricule',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.first_name}/${row.last_name}/${row.email}`, {
    id: 'employé',
    header: 'Employé',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.phone, {
    id: 'phone',
    header: 'Contact',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.profile[0].label, {
    id: 'poste',
    header: 'Poste',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.profile[0].pivot.contract_type, {
    id: 'type_contrat',
    header: 'Type de contrat',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.created_at.split('T')[0], {
    id: 'Date_arrive',
    header: "Date d'arrivé",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.id, {
    id: 'Action',
    header: '',
    cell: info => info.getValue(),
  })
];

export default {
    name: 'EmployeeTableComponent',
    components: {
        CustomTable,
        RefreshCw,FolderUp
    },
    data() {
        return {
            indivrapport: { user: {}, presences: [], exceptions: [], debut: null, fin: null },
            rapport: { users: [], debut: null, fin: null },
            rapportfilter: 'global',
            selectedemp: "",
            rapport_load: false,
            table_load: false,
            actu_load: false,
            employees: [],
            filter_status: 'actif',
            columnn: columnsRequest,
            profiles: [],
            shifts: [],
            date:null,
            date2:null
        }
    },
    mounted() {
        this.getProfiles()
        this.getData()
        this.getShifts()
    },
    methods: {
        selectType(type){
            if(this.filter_status == type) return;
            this.filter_status = type;
            this.getData(null,type);
        },

        getData(type = null,t = "actif") {
            this.table_load = true;
            if(type == 'refresh') this.actu_load = true;
            API.get('get'+(t == "actif" ? 'All' : "Ex")+'Employees')
                .then((res) => {
                    this.employees = res.data.data;
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{
                    this.table_load = false
                    if(type == 'refresh') this.actu_load = false;
                })
        },

        ExportToExcel(type, fn, dl, table) {
        var elt = document.getElementById(table);
        var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
        return dl ?
            XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }):
            XLSX.writeFile(wb, fn || ('Sells sheet - '+ new Date() +'.' + (type || 'xlsx')));
        },

        async getProfiles() {
            API.get('getAllProfiles')
                .then((res) => {
                    this.profiles = res.data.data
                })
                .catch((error) => {
                    console.error(error)
                })
        },

        async getShifts() {
            await API.get('shifts')
                .then((res) => {
                    this.shifts = res.data.data
                })
                .catch((error) => {
                    console.error(error)
                })
        },


        async getrapportglobal() {
            this.rapportfilter = 'global'
            this.rapport_load = true;
            const date = new Date();
            const years = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2,0);
            const periode = this.date ? this.date.split("-")[0] + "-"+ this.date.split("-")[1] : `${years}-${month}`
            API.get(`employeeRapportGlobal/${periode}`)
                .then((res) => {
                    this.rapport.users = res.data.data
                    this.rapport.debut = res.data.debut
                    this.rapport.fin = res.data.fin
                    this.rapport_load = false
                })
                .catch((error) => {
                    console.error(error)
                    this.rapport_load = false
                })
        },

        async getrapportindiv(id) {
            if (this.rapportfilter == 'indiv') {
                this.rapport_load = true;
                const date = new Date();
                const years = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2,0);
                const periode = this.date2 ? this.date2.split("-")[0] + "-"+ this.date2.split("-")[1] : `${years}-${month}`
                API.get('employeeRapportIndiv/' + id+"/"+periode)
                    .then((res) => {
                        this.indivrapport.exceptions = res.data.exceptions
                        this.indivrapport.presences = res.data.presences
                        this.indivrapport.user = res.data.data
                        this.indivrapport.debut = res.data.debut
                        this.indivrapport.fin = res.data.fin
                        this.rapport_load = false
                    })
                    .catch((error) => {
                        console.error(error)
                        this.rapport_load = false
                    })
            }
        },
        pdf(id) {
            html2pdf(document.getElementById(id));
        },

        excel(id) {
            html2pdf(document.getElementById(id));
        },
        pushDetails(id){
            if(this.filter_status == "actif"){
                router.push({path:"employes/"+id});
            }else{
                router.push({path: "employes/" + id,query: {exit: true}});
            }
        },
        exportData(){
            const header = ["Matricule","Nom","Prenom","Email","Sex","Date de naissance","Contact","Nationalité","Rib"]
            const employes = [header];
            this.employees.forEach((emplo)=>{
                const tab = [emplo["matricule"],emplo["first_name"],emplo["last_name"],emplo["email"],emplo["sexe"],emplo["birthdate"],emplo["phone"],emplo["nationality"],emplo["rib"]];
                employes.push(tab)
            })
            // Convert the data to a worksheet
            const worksheet = XLSX.utils.aoa_to_sheet(employes);
            // Create a workbook
            const workbook = XLSX.utils.book_new();
            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Liste_employees");
            // Generate the XLSX file
            const xlsx = XLSX.write(workbook, {type: "binary", bookType: "xlsx"});

            // Create a link to download the file
            const link = document.createElement("a");
            link.href = URL.createObjectURL(new Blob([xlsx], {type: "application/octet-stream"}));
            link.download = "data.xlsx";

            link.click();
        }
    }
}

</script>